import moment from 'moment';
import type { CoreTypes } from '../../core';
import type { CalendarEvent } from '../types/calendar-events';
import toRoom from './rooms';

export default (events: CalendarEvent[]): CoreTypes.MixedWithoutInternalId.Event[] => {
  if (!Array.isArray(events))
    throw new Error('(SS12000::From::CalendarEvents) CalendarEvent input is not of array type', { cause: 'invalid_input' });

  return events
    .map((event): CoreTypes.MixedWithoutInternalId.Event => ({
      ids:               event.id,
      start:             event.startTime.toString(),
      end:               event.endTime.toString(),
      duration:          moment(event.endTime).diff(event.endTime, 'm'),
      preferredDuration: moment(event.endTime).diff(event.endTime, 'm'),
      course:            event.activity.id,
      inLocations:       toRoom(event.rooms ?? []),
      //    resources:               toResource([])
    }));
};
